export var GiveawayRewardStatus;
(function (GiveawayRewardStatus) {
    GiveawayRewardStatus["REDEEMED"] = "REDEEMED";
})(GiveawayRewardStatus || (GiveawayRewardStatus = {}));
